import MailboxItemState from './mailbox-item-state'
import OrgSettings from '../services/models/org-settings'
import { jwtDecode } from 'jwt-decode'
import SentItemsProcessor from '../events/sent-items/sent-items-processor'

let state: SidebarState

class SidebarState {
  sidebarIsConnected: boolean = false
  sidebarIsAuthenticated: boolean = false
  userEmail: string = ''
  cirrusToken: string = ''
  resolveAccessToken: Promise<any> | null = null
  cirrusRefreshToken: string = ''
  refreshingToken: boolean = false
  testingGraphAccess: boolean = false
  useOfficeRestApiUrlShortcut: boolean = true
  itemChangedHandlerCount: number = 0
  currentItem: MailboxItemState
  graphAccessAlertSent: boolean = false
  graphLoginRequestSent: boolean = false

  sentItemsProcessor: SentItemsProcessor = new SentItemsProcessor()
  mailboxProcessingStarted: boolean = false

  constructor() {
    this.currentItem = new MailboxItemState()
  }

  async useCirrusToken(): Promise<string> {
    return this.resolveAccessToken || Promise.resolve(this.cirrusToken)
  }

  getCirrusUserId(): string {
    if (this.cirrusToken) {
      try {
        const decodedToken = jwtDecode(this.cirrusToken) as any
        return decodedToken.nameid
      } catch {
        // ignore and return null
      }
    }
    return null
  }

  getCirrusUserGuid(): string {
    if (this.cirrusToken) {
      try {
        const decodedToken = jwtDecode(this.cirrusToken) as any
        return decodedToken.uniqueid
      } catch {
        // ignore and return null
      }
    }
    return null
  }

  processOrgSettings(orgSettings: OrgSettings) {
    this.useOfficeRestApiUrlShortcut = orgSettings.UseOfficeRestApiUrlShortcut !== 'false'
  }

  startMailboxProcessing() {
    this.sentItemsProcessor.start()
    this.mailboxProcessingStarted = true
  }

  shouldSendGraphLoginRequest(): boolean {
    if (this.graphLoginRequestSent) {
      return false
    }
    this.graphLoginRequestSent = true
    return true
  }

  shouldSendGraphAccessAlert(): boolean {
    if (this.graphAccessAlertSent) {
      return false
    }
    this.graphAccessAlertSent = true
    return true
  }

  resetGraphAccessAlertFlag(): void {
    this.graphAccessAlertSent = false
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default state = new SidebarState()
